import produce from 'immer';

const INITIAL_STATE = {
  data: [],
  loading: false
};

export default function productPropertyAttachmentTypes(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case '@productPropertyAttachmentTypes/LIST_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@productPropertyAttachmentTypes/LIST_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.data = action.payload.list;
      });

    case '@productPropertyAttachmentTypes/LIST_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
      });

    default:
      return state;
  }
}
